import { CompetitorsDataConstants } from './CompetitorsData.constants';

const initialState = {
  appliedFilters: {
    activeTab: 'market_overview'
  }
};

// --- Reducer function to set applied filters
const appliedFiltersReducer = (state = initialState.appliedFilters, action) => {
  if (action.filterType === CompetitorsDataConstants.RESET_APPLIED_FILTERS) {
    return initialState.appliedFilters;
  }
  return { ...state, [action.filterType]: action.payload };
};
const CompetitorsDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case CompetitorsDataConstants.APPLIED_FILTERS:
      const appliedFilters = appliedFiltersReducer(state.appliedFilters, action);
      return {
        ...state,
        appliedFilters
      };

    case CompetitorsDataConstants.GET_CHART_QUERY_CONFIGS_REQUEST:
      return {
        ...state,
        response: {
          loading: true,
          error: false
        }
      };

    case CompetitorsDataConstants.GET_CHART_QUERY_CONFIGS_SUCCESS:
      return {
        ...state,
        response: {
          loading: false,
          error: false,
          data: [action.payload]
        }
      };

    case CompetitorsDataConstants.GET_CHART_QUERY_CONFIGS_ERROR:
      return {
        ...state,
        response: {
          loading: false,
          error: true
        }
      };

    default:
      return state;
  }
};

export default CompetitorsDataReducer;
